module.exports = "https://cdn-shared.mathletics.com/teacher-modules/course-assign/39/assets/images/a14b033ec52c8a63c6f0a00051c939a9.svg";


//////////////////
// WEBPACK FOOTER
// ./~/@3plearning/3p-teacheradmin-assets/assets/assign/icons/ico_student.svg
// module id = VO0O
// module chunks = 0